import React from 'react';
import SectionSummary, { SectionSummaryGroupPosition } from '../SectionSummary';

export type ContactInfoSummaryProps = {
  emailAddress: string;
  groupPosition?: SectionSummaryGroupPosition;
  onEditClicked?: () => void;
};

const ContactInfoSummary: React.FC<ContactInfoSummaryProps> = ({
  emailAddress,
  groupPosition,
  onEditClicked,
}: ContactInfoSummaryProps) => {
  return (
    <SectionSummary
      title="Email"
      content={<span data-user-email={emailAddress}>{emailAddress}</span>}
      displayActionButton
      actionButtonText="Edit"
      onActionButtonClicked={onEditClicked}
      groupPosition={groupPosition}
      toolTipKey="ContactInfo"
    />
  );
};

export default ContactInfoSummary;
